import {AccordionComponent} from './accordion.component';
import {AccordionGroupComponent} from './accordion.group.component';
import {AccordionHeaderComponent} from './accordion.header.component';
import {AccordionToggleComponent} from './accordion.toggle.component';
import {AccordionContentComponent} from './accordion.content.component';

export const ACCORDION_DIRECTIVES = [
    AccordionComponent,
    AccordionGroupComponent,
    AccordionHeaderComponent,
    AccordionToggleComponent,
    AccordionContentComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/index.ts